import Relay from 'react-relay/classic';
import RelayGraphQLMutation from 'react-relay/lib/RelayGraphQLMutation';

export default class PerQuestionSubmissionMutation {
  constructor(props) {
    this.props = props;
  }

  submissionQuery = Relay.QL`
    fragment on PerQuestionSubmissionPayload {
      card {
        rawData
      }
    }
  `;

  commit = (callbacks) => {
    const query = Relay.QL`
      mutation PerQuestionSubmission($input_0: PerQuestionSubmissionInput!) {
        perQuestionSubmission(input: $input) {
          ${this.submissionQuery}
          clientMutationId
        }
      }
    `;

    const dynamicObject = {};
    const { checkAnswersAttemptCount, flagged } = this.props;

    if (checkAnswersAttemptCount !== undefined) {
      dynamicObject.checkAnswersAttemptCount = checkAnswersAttemptCount;
    }
    if (this.props.flagged !== undefined) {
      dynamicObject.flagged = flagged;
    }

    const variables = {
      userId: this.props.userId,
      input: {
        rootOfferId: this.props.rootOfferId,
        userId: this.props.userId,
        cardId: this.props.cardId,
        answerObject: this.props.answerObject,
        actualSubmit: this.props.actualSubmit,
        // pathId: this.props.pathId,
        ...dynamicObject
      }
    };

    const mutation = new RelayGraphQLMutation(query, variables, null, Relay.Store, callbacks);

    const config = [{ type: 'FIELDS_CHANGE' }];
    config[0].fieldIDs = {
      card: this.props.mainId,
      course: this.props.courseGraphId,
      curriculum: this.props.pathGraphId
    };

    mutation.commit(config);
  };
}
